import { call, put, take, takeLatest } from "redux-saga/effects";
import {
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_SUCCESS,
  ORDER_DETAIL_LOADING,
} from "../actions/returnType";
import {
  CFA_ORDER_LIST,
  CFA_UPDATE_INVOICE,
  COMPANY_LIST,
  CURRENT_ORDER_LIST,
  ORDER_DETAIL,
  ORDER_HISTORY_LIST,
  ORDER_REMARKS_REASON_LIST,
  PROFILE_INFO,
  STOCK_RECONCILIATION_EXPORT,
  SUPPLY_ORDER_CFA,
  SUPPLY_ORDER_DETAIL,
  UPDATE_INVOICE,
  UPDATE_ORDER_STATUS,
  UPLOAD_INVOICE,
} from "../actions/types";

import * as orderApis from "../apis/orderApis.js";

export function* getProfileInfoWorker(action) {
  try {
    const res = yield call(orderApis.getProfileInfoApi);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* currentOrderListWorker(action) {
  try {
    const res = yield call(orderApis.currentOrderListApi, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* orderHistoryListWorker(action) {
  try {
    const res = yield call(orderApis.orderHistoryListApi, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* CFAOrderListWorker(action) {
  try {
    const res = yield call(orderApis.cfaOrderListApi, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* orderDetailWorker(action) {
  try {
    yield put({ type: ORDER_DETAIL_LOADING });
    const res = yield call(orderApis.orderDetailApi, { order_id: action.id });
    if (res.status == 200) {
      yield put({ type: ORDER_DETAILS_SUCCESS, data: res.data.data.data });
      yield action.onSuccess(res);
    } else {
      yield put({ type: ORDER_DETAILS_FAIL });
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* updateOrderStatusWorker(action) {
  try {
    const res = yield call(orderApis.updateOrderStatusApi, action.data);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* supplyOrderCFAWorker(action) {
  try {
    const res = yield call(orderApis.supplyOrderCFAApi, action.data);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* uploadInvoiceWorker(action) {
  try {
    const file = new FormData();
    file.append("file", action.file);
    const res = yield call(orderApis.uploadInvoice, file);

    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* updateInvoiceWorker(action) {
  try {
    const res = yield call(orderApis.updateInvoice, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* exportReconciliationWorker(action) {
  try {
    const res = yield call(orderApis.exportReconciliationApi, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* companyListWorker(action) {
  try {
    const res = yield call(orderApis.companyListApi);
    console.log(res);
    if (res.status == 200) {
      console.log("ddd", res.data.data);
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* supplyOrderDetailWorker(action) {
  try {
    yield put({ type: ORDER_DETAIL_LOADING });
    const res = yield call(orderApis.supplyOrderDetailApi, {
      order_id: action.id,
    });
    if (res.status == 200) {
      yield put({ type: ORDER_DETAILS_SUCCESS, data: res.data.data.data });
      yield action.onSuccess(res);
    } else {
      yield put({ type: ORDER_DETAILS_FAIL });
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}
export function* CFAupdateInvoiceWorker(action) {
  try {
    const res = yield call(orderApis.CFAupdateInvoice, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* orderRemarksReasonListWorker(action) {
  try {
    const res = yield call(orderApis.orderRemarksReasonListApi, {});
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.title,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* getProfileInfoWatcher() {
  yield takeLatest(PROFILE_INFO, getProfileInfoWorker);
}

export function* currentOrderListWatcher() {
  yield takeLatest(CURRENT_ORDER_LIST, currentOrderListWorker);
}

export function* orderHistoryListWatcher() {
  yield takeLatest(ORDER_HISTORY_LIST, orderHistoryListWorker);
}

export function* orderDetailWatcher() {
  yield takeLatest(ORDER_DETAIL, orderDetailWorker);
}

export function* updateOrderStatusWatcher() {
  yield takeLatest(UPDATE_ORDER_STATUS, updateOrderStatusWorker);
}

export function* uploadInvoiceWatcher() {
  yield takeLatest(UPLOAD_INVOICE, uploadInvoiceWorker);
}

export function* updateInvoiceWatcher() {
  yield takeLatest(UPDATE_INVOICE, updateInvoiceWorker);
}

export function* exportReconciliationWatcher() {
  yield takeLatest(STOCK_RECONCILIATION_EXPORT, exportReconciliationWorker);
}

export function* companyListWatcher() {
  yield takeLatest(COMPANY_LIST, companyListWorker);
}
export function* CFAOrderListWatcher() {
  yield takeLatest(CFA_ORDER_LIST, CFAOrderListWorker);
}
export function* supplyOrderCFAWatcher() {
  yield takeLatest(SUPPLY_ORDER_CFA, supplyOrderCFAWorker);
}
export function* supplyOrderDetailWatcher() {
  yield takeLatest(SUPPLY_ORDER_DETAIL, supplyOrderDetailWorker);
}
export function* CFAupdateInvoiceWatcher() {
  yield takeLatest(CFA_UPDATE_INVOICE, CFAupdateInvoiceWorker);
}
export function* orderRemarksReasonListWatcher() {
  yield takeLatest(ORDER_REMARKS_REASON_LIST, orderRemarksReasonListWorker);
}